import DreamRateUsageBadge from "../../dream-rate-usage-badge"
import PercentageInput from "../../../form/percentage-input"
import { usePendingSubscriptionsCount } from "../../../../hooks"

interface Props {
  name?: string
  label?: string
  tooltipText?: React.ReactNode
  placeholder?: string
  step?: number
}
const DreamRate = ({
  name = "trigger_rate",
  label = "Dream rate",
  tooltipText = (
    <>
      The rate that triggers rate alert notification
      <br />& emails to the lead.
    </>
  ),
  placeholder = "3.00",
  step = 0.25
}: Props) => {
  const { isFetching, maxReached } = usePendingSubscriptionsCount()
  return (
    <PercentageInput
      name={name}
      label={label}
      tooltipText={tooltipText}
      placeholder={placeholder}
      step={step}
      labelAddon={<DreamRateUsageBadge className="ml-auto !py-1" />}
      helpText={
        isFetching || !maxReached ? null : (
          <>
            Contact{" "}
            <a
              href="mailto:support@bankingbridge.com"
              className="text-blue-400 underline"
            >
              support@bankingbridge.com
            </a>{" "}
            to upgrade.
          </>
        )
      }
    />
  )
}

export default DreamRate
